import { createFileRoute } from '@tanstack/react-router';
import { PortalProfile } from '@/features/portal/PortalProfile';

export const Route = createFileRoute('/_portal/portal/profilo')({ component: PortalProfile });
